import React from 'react';
import PropTypes from 'prop-types';
import { BASE_URL, API } from 'CONST';
import { Label, Col, Row } from 'reactstrap';
import NewFileTable from 'components/shared/NewFileTable';

const VentaEnVerdeSeccionAdjuntos = ({
  newAntecedentes,
  oldAntecedentes,
  setNewAntecedentes,
  setOldAntecedentes,
  removeAdjunto,
  editableSection,
  setIsFormSaved,
}) => {
  const dataAdjuntos = {
    venta_en_verde_cuestionario: {
      label: 'Cuestionario',
      adjunto_docs: 'venta_en_verde_cuestionario_docs',
    },
    venta_en_verde_permiso_edificacion: {
      label: 'Permiso Edificación',
      adjunto_docs: 'venta_en_verde_permiso_edificacion_docs',
    },
    venta_en_verde_aprobacion_bancaria: {
      label: 'Aprobación Bancaria',
      adjunto_docs: 'venta_en_verde_aprobacion_bancaria_docs',
    },
  };
  return (
    <div>
      {Object.keys(dataAdjuntos).map((key) => {
        return (
          <div key={key}>
            <Row>
              <Col>
                <Label>{dataAdjuntos[key].label}</Label>
              </Col>
              <Col>
                <NewFileTable
                  handleAdd={(file) => {
                    setIsFormSaved(false);
                    setNewAntecedentes((prevState) => ({
                      ...prevState,
                      [key]: [...prevState[key], file],
                    }));
                  }}
                  handleDeleteNew={(file) => {
                    setIsFormSaved(false);
                    setNewAntecedentes((prevState) => ({
                      ...prevState,
                      [key]: prevState[key].filter((doc) => doc.uuid !== file.uuid),
                    }));
                  }}
                  handleDelete={(event) => {
                    setIsFormSaved(false);
                    removeAdjunto(event.id, key);
                    setOldAntecedentes((prevState) => ({
                      ...prevState,
                      [dataAdjuntos[key].adjunto_docs]: prevState[
                        dataAdjuntos[key].adjunto_docs
                      ].filter((doc) => doc.id !== event.id),
                    }));
                  }}
                  uploadUrl={`${BASE_URL}${API.upload}/`}
                  downloadUrl={`${BASE_URL}${API.download}/`}
                  newFiles={newAntecedentes[key]}
                  fileList={oldAntecedentes[dataAdjuntos[key].adjunto_docs]}
                  individualMaxFileSize={13}
                  globalMaxFileSize={20}
                  loginIdToken=""
                  readOnly={!editableSection}
                />
              </Col>
            </Row>
            <br />
          </div>
        );
      })}
    </div>
  );
};

VentaEnVerdeSeccionAdjuntos.propTypes = {
  newAntecedentes: PropTypes.shape().isRequired,
  oldAntecedentes: PropTypes.shape().isRequired,
  setNewAntecedentes: PropTypes.func.isRequired,
  setOldAntecedentes: PropTypes.func.isRequired,
  removeAdjunto: PropTypes.func.isRequired,
  editableSection: PropTypes.bool,
  setIsFormSaved: PropTypes.func.isRequired,
};

VentaEnVerdeSeccionAdjuntos.defaultProps = {
  editableSection: false,
};

export default VentaEnVerdeSeccionAdjuntos;
